module.exports = __webpack_public_path__ + "img/logo.2e4e5940.jpg";